<template>
  <div class="part modals create-customer-modal">
    <a-modal
      title="Create New Staff"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onCreate"
      @cancel="onCancel"
      :centered="true"
    >
      <a-form-model
        class="p-3 flex-grow-1"
        ref="staff"
        :model="staff"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <!-- Authentication -->
        <a-form-model-item label="Authentication" prop="username">
          <a-input-group compact>
            <a-input v-model="staff.username" style="width: 50%" placeholder="Username">
              <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
            </a-input>
            <a-input v-model="staff.password" style="width: 50%" placeholder="Password" type="password">
              <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
            </a-input>
          </a-input-group>
        </a-form-model-item>

        <!-- Name -->
        <a-form-model-item label="Name/Lastname" prop="name">
          <a-input-group compact>
            <a-input v-model="staff.name" style="width: 50%" placeholder="Name" />
            <a-input v-model="staff.lastname" style="width: 50%" placeholder="Last Name" />
          </a-input-group>
        </a-form-model-item>

        <!-- Display Name -->
        <a-form-model-item label="Display Name" prop="display_name">
          <a-input v-model="staff.display_name" placeholder="Display Name" />
        </a-form-model-item>

        <!-- Email -->
        <a-form-model-item label="Email" prop="email">
          <a-input v-model="staff.email" placeholder="Email" />
        </a-form-model-item>

        <!-- Phone -->
        <a-form-model-item label="Phone">
          <a-input-group compact>
            <a-input v-model="staff.phone" style="width: 50%" placeholder="Number" />
            <a-input v-model="staff.extension" style="width: 50%" placeholder="Extension" />
          </a-input-group>
        </a-form-model-item>

        <!-- Department/Job Title -->
        <a-form-model-item label="Department/Job Title">
          <a-input-group compact>
            <a-select v-model="staff.department" default-value="tech" style="width: 50%">
              <a-select-option
                v-for="department in options_['DEPARTMENT']"
                :key="department.key"
                :value="department.key"
              >
                {{ department.value }}
              </a-select-option>
            </a-select>

            <a-select v-model="staff.job_title" default-value="tech" style="width: 50%">
              <a-select-option v-for="job_title in options_['JOB_TITLES']" :key="job_title.key" :value="job_title.key">
                {{ job_title.value }}
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Location -->
        <a-form-model-item label="Location">
          <a-input v-model="staff.location" />
        </a-form-model-item>

        <!-- Address -->
        <a-form-model-item label="Address">
          <a-input v-model="staff.address" />
        </a-form-model-item>

        <!-- Bio -->
        <a-form-model-item label="Bio">
          <a-input v-model="staff.bio" type="textarea" :rows="4" />
        </a-form-model-item>

        <!-- Note -->
        <a-form-model-item label="Note">
          <a-input v-model="staff.note" type="textarea" />
        </a-form-model-item>

        <!-- Roles/Permissions -->
        <a-form-model-item label="Roles/Permissions">
          <a-input-group compact>
            <a-select v-model="staff.roles" default-value="employee" style="width: 50%">
              <a-select-option value="superadmin"> Superadmin </a-select-option>
              <a-select-option value="admin"> Admin </a-select-option>
              <a-select-option value="manager"> Manager </a-select-option>
              <a-select-option value="employee"> Employee </a-select-option>
              <a-select-option value="Worker"> Worker </a-select-option>
              <a-select-option value="visitor"> Visitor </a-select-option>
            </a-select>

            <a-select mode="tags" v-model="staff.permissions" default-value="tech" style="width: 50%">
              <a-select-option value="all"> All </a-select-option>
              <a-select-option value="default"> Default </a-select-option>
              <a-select-option value="crm"> CRM </a-select-option>
              <a-select-option value="pm"> PM </a-select-option>
              <a-select-option value="marketing"> MARKETING </a-select-option>
              <a-select-option value="system"> SYSTEM </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Active -->
        <a-form-model-item label="Active" prop="active">
          <a-switch v-model="staff.active" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import store from '@/store'
const KEY = 'CREATE_STAFF'
export default {
  name: 'create-staff-modal',
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      confirmLoading: false,
      staff: {
        active: true,
      },
      rules: {
        username: [
          { required: true, message: 'Please input username', trigger: 'blur' },
          { min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur' },
        ],
        name: [
          { required: true, message: 'Please input staff name', trigger: 'blur' },
          { min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur' },
        ],
        display_name: [
          { required: true, message: 'Please input staff display name', trigger: 'blur' },
          { min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Please input staff email', trigger: 'blur' },
          { min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    visible: {
      get() {
        return this.$store.getters['staffs/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('staffs/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    onCreate(e) {
      this.$refs.staff.validate((valid) => {
        if (valid) {
          store.dispatch('staffs/createStaff', this.staff)
        } else {
          this.$message.error('Oops, The staff creation failed!')
          return false
        }
      })
    },
    onCancel(e) {
      this.visible = false
    },
    onReset() {
      this.$refs.staff.resetFields()
    },
    onPlaceChanged(place) {
      if (place) {
        // console.log(place)
        if (place.formatted_address) {
          this.staff.raw_address = place.formatted_address
        }
        if (place.locality && place.administrative_area_level_1) {
          this.staff.location = `${place.locality},${place.administrative_area_level_1}`
        }
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped></style>
